export { default } from '../Percent'
export type { PercentProps } from '../Percent'
